module.exports = __webpack_public_path__ + "static/media/018.a677c63e.jpg";